import { modalRef } from './ref/modalRef';
import { navigateRef } from './ref/navigateRef';
const ROUTE_WHITELIST = new Set([
    '/login',
    '/checkout',
    '/unauthorized',
    '/error/db',
]);
const MODAL_TYPE_WHITELIST = [
    'info',
    'warning',
    'error',
    'success',
];
export function guardRoute(path) {
    if (!ROUTE_WHITELIST.has(path)) {
        throwError({ status: 403, message: `Route not allowed: ${path}` });
    }
}
export class AthenaError extends Error {
    constructor({ status, message, meta }) {
        super(message);
        this.status = status;
        if (meta)
            this.meta = meta;
        Object.setPrototypeOf(this, AthenaError.prototype);
    }
}
// -- Core Methods --
export function throwError(i) {
    throw new AthenaError(i);
}
export function sealLog(event, context) {
    const payload = {
        scope: 'AthenaSeal',
        ts: new Date().toISOString(),
        event,
        ...(context ?? {}),
    };
    console.log(JSON.stringify(payload));
}
export function assert(condition, errorInput) {
    if (!condition)
        throwError(errorInput);
}
export const AthenaCore = {
    throwError,
    sealLog,
    assert,
    guardRoute,
    openModal(params) {
        if (typeof window === 'undefined')
            return false;
        if (!modalRef.current) {
            console.warn('[AthenaCore] modalRef missing');
            return false;
        }
        modalRef.current.openModal(params);
        return true;
    },
    redirect(path) {
        if (typeof window === 'undefined')
            return false;
        if (!navigateRef.goTo) {
            console.warn('[AthenaCore] navigateRef missing');
            return false;
        }
        navigateRef.goTo(path);
        return true;
    },
    pingRoute(route, meta = {}) {
        const timestamp = new Date().toISOString();
        console.log(`[Athena Ping] ${timestamp} :: ${route}`, Object.keys(meta).length ? meta : '');
        switch (route) {
            case '/unauthorized':
                AthenaCore.openModal({
                    title: 'Session Expired',
                    message: 'Please sign in again to continue.',
                    type: 'warning',
                });
                break;
            case '/error/db':
                AthenaCore.reportPulse('db_error', {
                    origin: 'fetchUserSession',
                    ...meta,
                });
                break;
        }
    },
    reportPulse(label, details = {}) {
        console.log(`[Athena Pulse] :: ${label}`, details);
    },
};
